import { FC, useRef, useState } from "react";
import FormLayout from "../FormLayout";
import { IModule } from "../../../interfaces/IFurniture";
import { Card, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { useModal } from "../../../hooks/useModal";
import LoadingAnimation from "../../_common/Loading";
import { useToast } from "../../../hooks/useToast";
import CustomInput from "../../_common/CustomInput";
import furnitureController, { IEditModuleDto } from "../../../Api/furnitureController";

interface EditModuleFormProps {
    moduleId: string;
    furnitureId: string;
    moduleData?: IModule | null;
    onSetModules?: (modules: IModule[]) => void;
}

const EditModuleForm: FC<EditModuleFormProps> = ({
    moduleId,
    furnitureId,
    moduleData,
    onSetModules,
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [name, setName] = useState<string>(moduleData?.name || '');
    const [description, setDescription] = useState<string>(moduleData?.description || '');
    const [width, setWidth] = useState<number>(moduleData?.width || 0);
    const [height, setHeight] = useState<number>(moduleData?.height || 0);
    const [depth, setDepth] = useState<number>(moduleData?.depth || 0);
    const [moduleType, setModuleType] = useState<string | null>(moduleData?.moduleType || null);
    const toast = useRef(useToast()).current;
    const modal = useModal();


    const handleSaveModule = async () => {
        setLoading(true);
        const data: IEditModuleDto = {
            furnitureId,
            moduleId,
            name,
            description,
            width,
            height,
            depth,
            moduleType,
        }
        const res = await furnitureController.editModule(data)
        setLoading(false);
        if (!res.ok) return toast.error(res.message);
        onSetModules?.(res.editedFurniture?.modules || []);
        modal.close();
    }


    if (loading) return (
        <Card>
            <LoadingAnimation />
        </Card>
    )

    return (
        <FormLayout
            title="Edytuj moduł"
            onClickButton={handleSaveModule}
        >
            <CustomInput
                sx={{
                    width: '100%',
                }}
                mode="text"
                label="Nazwa"
                placeholder="Nazwa"
                value={name}
                setValue={setName}
                variant="filled"
            />
            <CustomInput
                sx={{
                    width: '100%',
                }}
                mode="multiline"
                maxRows={10}
                label="Opis"
                placeholder="Opis"
                value={description}
                setValue={setDescription}
                variant="filled"
            />
            <CustomInput
                sx={{
                    width: '100%',
                }}
                value={width}
                setValue={setWidth}
                mode="numeric"
                label={'szerokość'}
                variant="filled"
            />
            <CustomInput
                sx={{
                    width: '100%',
                }}
                value={depth}
                setValue={setDepth}
                mode="numeric"
                label={'głębokość'}
                variant="filled"
            />
            <CustomInput
                sx={{
                    width: '100%',
                }}
                value={height}
                setValue={setHeight}
                mode="numeric"
                label={'wysokość'}
                variant="filled"
            />
            <FormControl sx={{ mt: 2 }}>
                <FormLabel id="moduleTypeGroup">TYP</FormLabel>
                <RadioGroup
                    aria-labelledby="moduleTypeGroup"
                    name="radio-buttons-group"
                    row
                    value={moduleType}
                >
                    <FormControlLabel
                        onClick={() => setModuleType('left')}
                        value="left"
                        control={<Radio />}
                        label="LEWY" />
                    <FormControlLabel
                        onClick={() => setModuleType('middle')}
                        value="middle"
                        control={<Radio />}
                        label="WEWNĘTRZNY" />
                    <FormControlLabel
                        onClick={() => setModuleType('right')}
                        value="right"
                        control={<Radio />}
                        label="PRAWY" />
                    <FormControlLabel
                        onClick={() => setModuleType('corner')}
                        value="corner"
                        control={<Radio />}
                        label="NAROŻNIK" />
                    <FormControlLabel
                        onClick={() => setModuleType('solo')}
                        value="solo"
                        control={<Radio />}
                        label="SOLO" />
                </RadioGroup>
            </FormControl>
        </FormLayout>
    )
}

export default EditModuleForm;